import React, { useState } from 'react';
import './Contact.css';
import PixieDust from '../components/PixieDust';

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.35l3-.01a2 2 0 0 1 2 1.72c.13.96.35 1.9.65 2.81a2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.3 1.85.52 2.81.65a2 2 0 0 1 1.72 2.03z"/>
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" width="14" height="14">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    
    // Create mailto link with form data
    const recipientEmail = 'chrystal.harris@playcationtravel.com';
    const subject = formData.subject || `Contact Form Submission from ${formData.name}`;
    const body = `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`;
    
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message after a brief delay
    setTimeout(() => {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <PixieDust count={9} className="pixie-dust--short" />
        <div className="container">
          <h1>Get in Touch</h1>
          <p>Ready to start planning your magical Disney vacation? Let's talk!</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Let's Make Magic Together</h2>
              <p>
                I'm here to help you plan the Disney vacation of your dreams.
                Whether you're a first-time visitor or a seasoned Disney veteran,
                I'll work with you to create a personalized experience that's
                perfect for your family.
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon"><MailIcon /></div>
                  <div className="method-details">
                    <h3>Email</h3>
                    <p>chrystal.harris@playcationtravel.com</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon"><PhoneIcon /></div>
                  <div className="method-details">
                    <h3>Phone</h3>
                    <p>519-282-7508</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon"><ClockIcon /></div>
                  <div className="method-details">
                    <h3>Hours</h3>
                    <p>Monday – Friday: 9AM – 6PM EST</p>
                    <p>Saturday: 10AM – 4PM EST</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon"><InstagramIcon /></div>
                  <div className="method-details">
                    <h3>Instagram</h3>
                    <p>@magicallymousebound</p>
                  </div>
                </div>
              </div>

              <div className="contact-note">
                <h3>What to Expect</h3>
                <ul>
                  <li><CheckIcon /><span>Free consultation to discuss your Disney dreams</span></li>
                  <li><CheckIcon /><span>Personalized vacation planning</span></li>
                  <li><CheckIcon /><span>Ongoing support throughout your journey</span></li>
                  <li><CheckIcon /><span>Access to exclusive Disney deals and packages</span></li>
                </ul>
              </div>
            </div>

            <div className="contact-form-container">
              <h2>Send Me a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="6"
                    required
                    disabled={isSubmitting}
                    placeholder="Tell me about your Disney vacation dreams..."
                  />
                </div>

                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>

                {submitStatus === 'success' && (
                  <div className="success-message">
                    <p>Thank you! I'll get back to you as soon as possible.</p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
